import BaseLayout from './Base'

export default { BaseLayout }
